import {
  RadioGroup,
  RichTextField,
  SingleSelectField,
  TextField,
} from "components/RenderInput"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { Field, formValueSelector, isDirty, reset } from "redux-form"
import { getTimezones } from "utils"
import { FORM_NAMES } from "constants/index"
import UnsavedAlertModal from "components/UnsavedAlertModal"
import locationAutocomplete from "./locationAutocomplete"

const DetailsTab = ({
  selectedSubCalendar,
  handleSave,
  tabIsActive,
  resetForm,
  isDirty,
  locationType,
}) => {
  const [showAlertModal, setShowAlertModal] = useState(false)

  useEffect(() => {
    if (!tabIsActive && isDirty) {
      setShowAlertModal(true)
    }
  }, [tabIsActive])

  return (
    <React.Fragment>
      <Card>
        <CardHeader>
          <h4>DETAILS</h4>
        </CardHeader>
        <CardBody>
          <Row>
            <Col xs="auto" className="mt-2" style={{ minWidth: "175px" }}>
              <label>Name of Sub Calendar: </label>
            </Col>
            <Col>
              <Field
                name="name"
                component={TextField}
                placeholder="Name"
                disabled={!!selectedSubCalendar}
              />
            </Col>
          </Row>
          <Row className="my-3">
            <Col xs={12}>
              <label>Description:</label>
            </Col>
            <Col>
              <Field name="description" component={RichTextField} />
            </Col>
          </Row>
          <Row className="my-3">
            <Col xs="auto" style={{ minWidth: "175px" }}>
              <label>Location:</label>
            </Col>
            <Col xs="auto" className="mt-1">
              <Field
                name="location"
                type="radio"
                component={RadioGroup}
                label="Link"
                value="1"
              />
            </Col>
            <Col xs="auto" className="mt-1">
              <Field
                name="location"
                type="radio"
                component={RadioGroup}
                label="Address"
                value="2"
              />
            </Col>
            <Col>
              {locationType === "2" ? (
                <Field
                  name="locationDetails.address"
                  component={locationAutocomplete}
                />
              ) : (
                <Field name="locationText" component={TextField} />
              )}
            </Col>
          </Row>
          <Row className="my-3">
            <Col xs="auto" className="mt-2" style={{ minWidth: "175px" }}>
              <label>Timezone: </label>
            </Col>
            <Col xs="auto">
              <div style={{ width: "250px" }}>
                <Field
                  name="timezone"
                  component={SingleSelectField}
                  options={getTimezones()}
                  isSearchable={false}
                />
              </div>
            </Col>
          </Row>
          <Row className="my-3">
            <Col xs="auto" className="mt-2">
              <label>In App Notes Field Title: </label>
            </Col>
            <Col>
              <Field
                name="inAppNotes"
                component={TextField}
                placeholder="In App Notes Field Title"
              />
            </Col>
          </Row>
        </CardBody>
      </Card>
      <UnsavedAlertModal
        isOpen={showAlertModal}
        onClose={() => {
          setShowAlertModal(false)
          resetForm()
        }}
        onSave={() => {
          handleSave()
          setShowAlertModal(false)
        }}
      />
    </React.Fragment>
  )
}

const selector = formValueSelector(FORM_NAMES.SUB_CALENDARS)

const mapStateToProps = state => ({
  selectedSubCalendar: state.BookingsFeature.selectedSubCalendar,
  isDirty: isDirty(FORM_NAMES.SUB_CALENDARS)(state, ...["details"]),
  locationType: selector(state, "details.location"),
})

const mapDispatchToProps = dispatch => ({
  resetForm: () => dispatch(reset(FORM_NAMES.SUB_CALENDARS)),
})

export default connect(mapStateToProps, mapDispatchToProps)(DetailsTab)
